import { Pipe, PipeTransform, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { isNil } from 'lodash';
import { MonitoringPlanType } from 'mbs-ui-shared@models/MonitoringPlanType';
import { MonitoringPlanTypeUtil } from 'mbs-ui-shared@utils/monitoringPlanTypeUtil';

@Pipe({
  name: 'monitoringPlanType'
})
export class MonitoringPlanTypePipe implements PipeTransform {
  private i18N = inject(I18NextPipe);

  transform(value: number, args?: any): any {
    const typeValue = typeof value;
    const newValue = typeValue === 'number' ? value : typeValue === 'string' ? +MonitoringPlanType[value] : null;
    if (!isNil(newValue)) {
      let prop = null;
      Array.isArray(args) ? (prop = args[0]) : (prop = args);

      switch (prop) {
        case 'statusIcon':
          return MonitoringPlanTypeUtil.getTableIcon(newValue);
        case 'statusName':
          return MonitoringPlanTypeUtil.GetStatusName(newValue);
        case 'name':
          return MonitoringPlanTypeUtil.getText(newValue, this.i18N);
        case 'iconClass':
        default:
          return MonitoringPlanTypeUtil.getIcon(newValue);
      }
    }
  }
}
